import { ScadaLabel } from 'components/dashboard/scada/scadaTypes';
import { create } from 'zustand'

type Scada = {
	scadaId: string;
	labels: ScadaLabel[];
}

type ScadaLabelsState = {
	scadaMap: Map<string, ScadaLabel[]>;
  addScada: (scada: Scada) => void;
	updateScadaLabels: (id: string, labels: ScadaLabel[]) => void;
  updateScadaLabelXY: (id: string, identifier: string, x: number, y: number) => void;
};

export const useScadaStore = create<ScadaLabelsState>()(
			set => ({
				scadaMap: new Map<string, ScadaLabel[]>(),
				addScada: newScada =>
					set(state => { 
						state.scadaMap.set(newScada.scadaId, newScada.labels);
						return state
					}),
				updateScadaLabels: (id, labels) => 
					set(state => {
						state.scadaMap.set(id, labels);
						return state;
					}),
				updateScadaLabelXY: (id, identifier, x, y) =>
					set(state => {
						const labels = state.scadaMap.get(id)
						if (!labels) return state;
						state.scadaMap.set(
							id,
							labels.map(l =>
								l.identifier === identifier
									? { ...l, xCoord: x, yCoord: y }
									: l,
							),
						);
						return state;
				}),
			}),

);